import { RepAprProductByTerms, ProductSchema } from "banco-components";
import { Calculations } from "banco/util/calculations";
import z from "zod";

// eslint-disable-next-line max-statements
export const useTermsCalculations = (
  representative_products: z.infer<typeof RepAprProductByTerms>,
  total_loan_value?: number,
  tenure?: string,
  previous_product?: z.infer<typeof ProductSchema>,
  top_up?: boolean,
  // eslint-disable-next-line max-params
) => {
  if (!total_loan_value || !tenure) { return null; }

  if (top_up && !previous_product) {
    throw new Error("Previous product was not supplied for top up application");
  }

  const previousProductApr = previous_product ? previous_product.apr : Number.MAX_VALUE;
  const foundRepProduct = representative_products.find(
    (prod) =>
      total_loan_value >= prod.min &&
      total_loan_value <= prod.max
  )?.product_by_tenure[tenure];

  if (!foundRepProduct) { return null; }

  const product = top_up && (previousProductApr < foundRepProduct.apr)
    ? previous_product
    : foundRepProduct;

  const totalRepayable = Calculations.totalPayable(
    total_loan_value,
    Number(tenure),
    product?.fee_rate ?? "0",
    product?.nominal_annual_interest_rate ?? "0"
  );
  const interestAndFees = totalRepayable - total_loan_value;
  const approximateMonthlyPayment = totalRepayable / Number(tenure);

  return {
    totalRepayable,
    interestAndFees,
    approximateMonthlyPayment,
    product,
  };
};
